<template>
<div>
  <b-row>
    <b-col cols="7" style="margin-top: 10%">
      <b-container>
        <img src="@/assets/images/background1.png" width="100%"/>
      </b-container>
      <b-col cols="12">
        <b-container style="margin-top:10% ">
          <h1 style="text-align: center; font-size: 1.2rem">ثبت نام</h1>
          <p style="font-size: 1rem; text-align: center"> کافیست آدرس والت خود را وارد کنید</p>
        </b-container>
      </b-col>
    </b-col>
    <b-col cols="5">
      <h1>....1</h1>
    </b-col>
  </b-row>
</div>
</template>

<script>
export default {
  name: "Bitcoin",
  created() {
    this.$store.state.isCompName = 'bitcoin';
  }
}
</script>

<style scoped>

</style>